import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { NovaGto } from '../../base/vo/nova-gto';
import { FormularioOrtodontia } from '../../base/vo/formulario-ortodontia';

@Component({
    selector: 'app-ortodontia',
    templateUrl: './ortodontia.component.html',
    styleUrls: ['./ortodontia.component.css']
})
export class OrtodontiaComponent implements OnInit {

    @Input() novaGto: NovaGto;
    @Input() exibeResumo: boolean = false;
    @Output() esconderFiltrosEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() mostrarBotaoEvent: EventEmitter<boolean> = new EventEmitter<boolean>(true);
    @Output() nextStepEvent = new EventEmitter();
    
    public isPassoUm = true;

    constructor() { }

    ngOnInit() {
        this.mostrarBotaoEvent.emit(false) ;
    }

    private irPassoDois(){
        this.isPassoUm = false;
        this.esconderFiltrosEvent.emit(true);
    }

    private irParaResumo(){
        this.nextStepEvent.emit();
    }

}



// WEBPACK FOOTER //
// ./src/app/components/ortodontia/ortodontia/ortodontia.component.ts